module.exports = "/images/mountain_right_2x.png";